import { cn } from '@/lib/utils';
import { X } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

import {
    DMRightSidebar,
    DMRightSidebarContent,
    DMRightSidebarHeader
} from './dm-right-sidebar';
import type { ExpandedSidebarProps } from './types';

export function ExpandedSidebar({
    title,
    itemCount,
    onClose,
    children,
    surfaceClassName = 'bg-muted/50',
    edgeClassName
}: ExpandedSidebarProps) {
    return (
        <DMRightSidebar
            className={cn(
                'border-border border-l',
                surfaceClassName,
                edgeClassName
            )}
        >
            <DMRightSidebarHeader className="bg-background px-6 py-2 border-border border-b">
                <div className="relative items-center gap-2 grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] w-full">
                    <div className="flex items-center gap-2.5 min-w-0 overflow-hidden">
                        <span className="font-medium text-foreground text-base shrink-0">
                            {title}
                        </span>
                        {itemCount !== undefined && (
                            <Badge
                                variant="outline"
                                className="px-3 py-1 rounded-full font-medium text-xs whitespace-nowrap shrink-0"
                            >
                                {itemCount} {itemCount === 1 ? 'item' : 'items'}
                            </Badge>
                        )}
                        <span
                            id="sidebar-header-title-slot"
                            className="flex items-center gap-2 min-w-0"
                        />
                    </div>
                    <div
                        id="sidebar-header-center-slot"
                        className="flex flex-col justify-center items-center"
                    />
                    <div className="flex justify-self-end items-center gap-1">
                        <div
                            id="sidebar-header-actions-slot"
                            className="flex items-center"
                        />
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={onClose}
                        >
                            <X strokeWidth={1.5} />
                        </Button>
                    </div>
                </div>
            </DMRightSidebarHeader>

            <DMRightSidebarContent
                className={cn('flex-1 p-6 overflow-y-auto', surfaceClassName)}
            >
                {children}
            </DMRightSidebarContent>
        </DMRightSidebar>
    );
}
